import { isNumber } from 'lodash';
import { DateTime } from 'luxon';
export const dateFromNumber = (number: number): String => DateTime.fromMillis(number).toFormat("dd.MM.yyyy");
export const dateAsString = (number: number): String => DateTime.fromMillis(number).toFormat("dd.MM.yyyy").toString();
export const dateTimeAsString = (number: number): String => DateTime.fromMillis(number).toFormat("dd.MM.yyyy HH:mm").toString();
export const checkIfDateWasInPast = (number: number): boolean => DateTime.local().toMillis() > number;
export const rangeToString = (start: DateTime, end: DateTime): string => {
    if(start.day===end.day) {
        return `${start.weekdayShort} ${start.toFormat('HH:mm')} - ${end.toFormat('HH:mm')}`;
    } else {
        return `${start.weekdayShort} ${start.toFormat('HH:mm')} - ${end.weekdayShort}  ${end.toFormat('HH:mm')}`;
    }
}
export const ageRangeToString = (younger: string,older:string,start?: number, end?: number): string => {
    if(start && end) {
        return `${start} - ${end}`;
    } else if (start) {
        return `${start} ${older}`;
    } else{
        return `${end} ${younger}`;
    }

}
export const toDate = (date: number | DateTime | undefined): any => isNumber(date) ? DateTime.fromMillis(date) : date